export default "__VITE_ASSET__BVPx2Ex2__"